
import type { PropOptions } from 'vue';
import Vue from 'vue';
import JobsNextButton from '~/components/partials/jobs/JobsNextButton.vue';
import JobsStep from '~/components/partials/jobs/JobsStep.vue';
import JobsInput from '~/components/partials/jobs/JobsInput.vue';
import { loadingState } from '~/components/common/constants';
import type { Testimonial } from '~/types/graphql';
import type { FormState } from '~/types/common';

interface IData {
  placeholder: string;
  description: string;
  preventAnimation: boolean;
  animateIndex: number;
}

export default Vue.extend({
  name: 'PublicPortfolioTestifyWords',
  components: { JobsInput, JobsStep, JobsNextButton },
  props: {
    testimonial: {
      type: Object,
      required: true,
    } as PropOptions<Testimonial>,
    formState: {
      type: String,
      required: true,
    } as PropOptions<FormState>,
  },
  data(): IData {
    return {
      description: this.testimonial.description || '',
      placeholder: '',
      preventAnimation: false,
      animateIndex: 0,
    };
  },
  computed: {
    phrases(): Array<string> {
      const firstname = 'Jenny';
      return [
        `${firstname} impressed me when...`,
        `My favorite thing about ${firstname} is...`,
        `I enjoy working with ${firstname} because...`,
      ];
    },
    isButtonDisabled(): boolean {
      return !this.description || this.formState === loadingState.SUBMITTING;
    },
  },
  mounted() {
    this.animateNext();
  },
  methods: {
    handleSave(): void {
      this.$emit('next', { description: this.description });
    },
    onFocus(): void {
      if (this.preventAnimation) return;

      this.preventAnimation = true;
      this.placeholder = '';
    },
    onBlur(): void {
      if (this.description.length) return;

      this.preventAnimation = false;
      this.animateIndex = 0;
      this.animateNext();
    },
    animateDelete(): void {
      if (this.preventAnimation) {
        return;
      }

      if (this.placeholder.length < 2) {
        this.placeholder = ' ';
        setTimeout(this.animateNext, 500);
      } else {
        this.placeholder = this.placeholder.slice(0, -1);
        setTimeout(this.animateDelete, 15);
      }
    },
    animateNext(): void {
      if (this.preventAnimation) {
        return;
      }

      const phrase = this.phrases[this.animateIndex];
      this.animateIndex = this.animateIndex < this.phrases.length - 1 ? this.animateIndex + 1 : 0;
      if (!phrase) {
        return;
      }
      const letters = phrase.split('');
      const animateLetters = (letters: Array<string>) => {
        if (this.preventAnimation) {
          return;
        }
        if (letters.length < 1) {
          setTimeout(() => this.animateDelete(), 2000);
          return;
        }
        const letter = letters.shift();
        this.placeholder = this.placeholder + letter;
        setTimeout(() => animateLetters(letters), Math.round(Math.random() * 50));
      };
      animateLetters(letters);
    },
  },
});
